export const judgeClient = function() {
  let u = navigator.userAgent;
  let isAndroid = u.indexOf('Android') > -1 || u.indexOf('Adr') > -1; // 判断是否是 android终端
  let isIOS = !!u.match(/\(i[^;]+;( U;)? CPU.+Mac OS X/); // 判断是否是 ios终端
  if (isAndroid === true) {
    return 'Android';
  } else if (isIOS === true) {
    return 'iOS';
  } else {
    return 'PC';
  }
};

/**
 * 当前设备是否为手机
 */
export const isMobile = function() {
  return document.documentElement.clientWidth < 500;
};

const otherDuration = [
  {
    text: '6小时',
    value: `${60 * 6}`
  },
  {
    text: '12小时',
    value: `${60 * 12}`
  },
  {
    text: '一天',
    value: `${60 * 24}`
  },
  {
    text: '两天',
    value: `${60 * 24 * 2}`
  },
  {
    text: '三天',
    value: `${60 * 24 * 3}`
  },
  {
    text: '四天',
    value: `${60 * 24 * 4}`
  },
  {
    text: '五天',
    value: `${60 * 24 * 5}`
  }
];
export const generateDuration = function(min, max, step) {
  let duration = [];
  if (min < max && max - min > step) {
    for (let time = min; time <= max; time += step) {
      const item = {
        text: `${time}分钟`,
        value: `${time}`
      };
      duration.push(item);
    }
  }

  return [...duration, ...otherDuration];
};
